import { useEffect, useLayoutEffect, useState } from 'react';
import {
  addGeofenceAction,
  getGeofencesAction,
  updateGeofenceAction
} from '../../../redux/reducer/yaantracSlices/geofenceSlice';
import {
  map,
  updateZoom
} from '../../../../../common/redux/reducer/commonSlices/mapSlice';
import {
  CirclePropsF,
  updateFence,
  updateFenceById,
  updateIsShow
} from '../../../../../common/redux/reducer/commonSlices/circleSlice';
import { updateCenter as updateMapCenter } from '../../../../../common/redux/reducer/commonSlices/mapSlice';
import {
  PolygonPropsF,
  updateIsShowDrawingManager,
  updateIsShowPolygon,
  updatePolygonFenceById,
  updatePolygonFences
} from '../../../../../common/redux/reducer/commonSlices/polygonSlice';
import { tripsDeviceAction } from '../../../redux/reducer/yaantracSlices/mytripsSlice';
import { mapVehiclesStatusAction } from '../../../redux/reducer/yaantracSlices/dashboardSlice';
import { updateToast } from '../../../../../common/redux/reducer/commonSlices/toastSlice';
import { findAddress, isValidPolygon } from '../../../../../utils/commonFunctions';

export const useGeofenceDispatch = ({
  data,
  isOpen,
  dispatch,
  createAbort,
  cardOpen,
  setRow,
  getGeofences
}: any) => {
  useLayoutEffect(() => {
    if (data?.length > 0) {
      const datas = data?.map((value: any, index: number) => ({
        ...value,
        activeColor: false
      }));
      setRow(datas);
    } else if (data?.length < 0) {
      setRow([]);
    }
  }, [data]);

  useEffect(() => {
    if (data?.length > 0 && isOpen === '' && !cardOpen) {
      const circularLocations = data
        ?.filter((item: any) => item?.geoType === 'circular')
        ?.map((item: any) => item?.latAndLongDetails?.[0] || []);

      const polygonGeofences = getGeofences('polygon') as PolygonPropsF[];
      dispatch(updatePolygonFences(polygonGeofences));

      const geofences = getGeofences('circular') as CirclePropsF[];
      dispatch(updateFence(geofences));
      dispatch(updateIsShow(true));
      dispatch(updateIsShowPolygon(true));

      const polygonLocations = data
        ?.filter((item: any) => item?.geoType === 'polygon')
        ?.map((item: any) => item?.latAndLongDetails || []);

      if (polygonLocations?.length > 0 || circularLocations?.length > 0) {
        dispatch(updateMapCenter([polygonLocations?.flat(), circularLocations].flat()));
        dispatch(updateZoom([polygonLocations?.flat(), circularLocations].flat()));
      }
    }
    if (data?.length === 0) {
      dispatch(updateFence([]));
      dispatch(updatePolygonFences([]));
    }
  }, [data, data?.length, isOpen, cardOpen]);

  useEffect(() => {
    const signal = createAbort()?.abortCall?.signal;
    dispatch(getGeofencesAction({ signal: signal }));
    dispatch(tripsDeviceAction());
    dispatch(
      mapVehiclesStatusAction({
        arg1: 'total',
        arg2: false,
        signal
      })
    );

    return () => {
      createAbort()?.abortCall?.abort();
      dispatch(updatePolygonFences([]));
      dispatch(updateFence([]));
      dispatch(map([]));
    };
  }, []);
};

export const useGeofenceFormDispatch = ({
  address,
  clearErrors,
  filteredRow,
  setValue,
  fences,
  dispatch,
  isCircular,
  polygonFences,
  isOpen,
  setAddress,
  data,
  getGeofences,
  setIsCircular,
  setIsUpdate,
  abortController,
  isUpdate,
  setSearchValue,
  setIsOpen,
  setFilteredRow,
  setToggleLock,
  reset
}: any) => {
  const [geoZoneID, setGeoZoneID] = useState<any>();

  const onClose = () => {
    setFilteredRow(null);
    reset({ vehicle: '', location: '', radius: '' });
    setIsOpen('');
    setAddress(null);
    setIsUpdate(false);
    setIsCircular(true);
    dispatch(updatePolygonFences([]));
    dispatch(updateFence([]));
    dispatch(updateMapCenter([]));
    dispatch(map([]));
    dispatch(updateIsShowDrawingManager(false));
    setValue('geoType', 'circular');
  };

  const onSubmit = async (params: any) => {
    if (abortController.current) abortController.current.abort();
    abortController.current = new AbortController();
    const { signal } = abortController.current;

    if (params?.geoType === 'polygon') {
      if (!params?.location?.length && !isUpdate) {
        dispatch(
          updateToast({ show: true, severity: 'error', message: 'Please draw polygon' })
        );
        return;
      }

      if (!isValidPolygon(params?.location)) {
        dispatch(
          updateToast({
            show: true,
            severity: 'error',
            message: 'Please draw valid polygon'
          })
        );
        return;
      }
    }

    const updatedPolygon =
      params?.geoType === 'polygon' &&
      params?.location?.map((item: any) => ({
        lat: item?.lat,
        lng: item?.lng
      }));

    let latAndLong =
      params?.geoType === 'polygon'
        ? updatedPolygon
        : [
            {
              lat: address?.geometry
                ? address?.geometry?.location?.lat()
                : filteredRow?.latAndLongDetails[0]?.lat,
              lng: address?.geometry
                ? address?.geometry?.location?.lng()
                : filteredRow?.latAndLongDetails[0]?.lng
            }
          ];

    let payload = {
      geoZoneName: params?.geoZoneName,
      geoType: params?.geoType,
      latAndLong: latAndLong,
      location:
        params?.geoType === 'circular'
          ? params?.location
          : await findAddress(params?.location[0]?.lat, params?.location[0]?.lng),
      radius: params?.geoType === 'circular' ? Number(params?.radius) : null,
      shapeColor: '#19A7CE'
    };

    if (!isUpdate) {
      const action1 = await dispatch(addGeofenceAction(payload));
      if (action1?.type === addGeofenceAction?.fulfilled?.type) {
        setSearchValue('searchFilter' as any, '');
        setIsOpen('');
        onClose();
        setFilteredRow(null);
        await dispatch(getGeofencesAction({ signal: signal }));
      }
    } else {
      let updatePayloads: any = {
        payload,
        geoZoneID: geoZoneID
      };
      const action2 = await dispatch(updateGeofenceAction(updatePayloads));
      if (action2?.type === updateGeofenceAction?.fulfilled?.type) {
        setIsOpen('');
        onClose();
        setSearchValue('searchFilter' as any, '');
        setFilteredRow(null);
        await dispatch(getGeofencesAction({ signal: signal }));
      }
    }
    setToggleLock(false);
  };
  useEffect(() => {
    if (address?.geometry?.location) {
      clearErrors('location');

      let center = {
        lat: address?.geometry?.location?.lat(),
        lng: address?.geometry?.location?.lng()
      };

      if (filteredRow) {
        setValue('radius', filteredRow?.radius);
        const ifFences = fences
          ?.map((item: any) => item.id)
          .includes(filteredRow?.geoZoneId);
        if (!ifFences) {
          dispatch(updateFence([...fences, { id: 'new', center, radius: 1000 }]));
          setValue('radius', 1);
        } else {
          dispatch(
            updateFenceById({
              id: filteredRow?.geoZoneId,
              center,
              radius: filteredRow?.radius * 1000
            })
          );
        }
      } else {
        const hasNew = fences?.some((obj: any) => obj.id === 'new');
        if (hasNew) {
          const [newFence]: any = fences?.filter((obj: any) => obj.id === 'new');
          setValue('radius', newFence?.radius / 1000);
          dispatch(
            updateFenceById({
              id: newFence?.id,
              center,
              radius: newFence?.radius
            })
          );
        } else {
          setValue('radius', 1);
          dispatch(updateFence([...fences, { id: 'new', center, radius: 1000 }]));
          dispatch(updateIsShow(true));
        }
      }

      dispatch(updateMapCenter([center]));
      dispatch(updateZoom([center]));
      clearErrors('radius');
    }
    let formatted_address = address?.formatted_address;
    setValue('location', formatted_address);
  }, [address]);

  useEffect(() => {
    if (!isCircular) {
      const [newFence] = polygonFences?.filter((item: any) =>
        filteredRow ? item?.id === filteredRow?.geoZoneId : item?.id === 'new'
      );
      setValue('location', newFence?.paths);
      clearErrors('location');
    }
  }, [polygonFences, isCircular, filteredRow]);

  useEffect(() => {
    if ((filteredRow && isOpen !== 'Assign Geofence') || isOpen === 'Add Geofence') {
      dispatch(map([]));
      const circularGeofences = getGeofences('circular') as CirclePropsF[];
      const polygonGeofences = getGeofences('polygon') as PolygonPropsF[];

      const circularCoord = circularGeofences?.map((item: any) => item?.center);
      const polygonCoord = polygonGeofences?.map((item: any) => item?.paths)?.flat();

      dispatch(updateFence(circularGeofences));
      dispatch(updatePolygonFences(polygonGeofences));
      dispatch(updateZoom([...polygonCoord, ...circularCoord]));
      dispatch(updateMapCenter([...polygonCoord, ...circularCoord]));

      if (filteredRow?.geoType === 'polygon') {
        dispatch(updateIsShowDrawingManager(true));
        setIsCircular(filteredRow?.geoType === 'circular');
        setIsUpdate(true);
        setValue('geoType', 'polygon');
        setValue('geoZoneName', filteredRow?.geofenceName);
      }
      if (filteredRow?.geoType === 'circular') {
        dispatch(updateIsShow(true));
        dispatch(
          updateFenceById({
            id: filteredRow?.geoZoneId,
            center: filteredRow?.latAndLongDetails?.[0],
            radius: filteredRow?.radius * 1000
          })
        );
        setValue('geoZoneName', filteredRow?.geofenceName);
        setValue('geoType', 'circular');
        setValue('location', filteredRow?.location ? filteredRow?.location : 'Chennai');
        setValue('radius', filteredRow?.radius);
        setAddress({
          formatted_address: filteredRow?.location ? filteredRow?.location : 'Chennai',
          latitude: filteredRow?.lat,
          longitude: filteredRow?.lng
        });
      }
      if (filteredRow && isOpen === 'Update Geofence') {
        const [newFence] = data?.filter((item: any) => item?.id === filteredRow?.id);
        dispatch(
          updatePolygonFenceById({
            id: filteredRow?.geoZoneId,
            paths: newFence?.latAndLongDetails
          })
        );

        if (filteredRow?.geoType === 'circular') {
          dispatch(
            updateFenceById({
              id: filteredRow?.geoZoneId,
              center: filteredRow?.latAndLongDetails?.[0],
              radius: filteredRow?.radius * 1000
            })
          );
        }
      }
      setGeoZoneID(filteredRow?.geoZoneId);
    }
  }, [filteredRow, isOpen]);
  return { onSubmit, onClose };
};
